import { useAuth } from '@/contexts/AuthContext';
import { AlertTriangle, X } from 'lucide-react';

export default function ImpersonationBanner() {
  const { isImpersonating, impersonationSession, endImpersonation } = useAuth();

  if (!isImpersonating || !impersonationSession) return null;

  const handleEnd = async () => {
    try {
      await endImpersonation();
      window.location.href = '/admin';
    } catch (err) {
      console.error('Failed to end impersonation:', err);
    }
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] bg-[#F72585] text-white py-2 px-3 md:px-4 shadow-lg"
      data-testid="impersonation-banner"
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <AlertTriangle className="w-4 h-4 flex-shrink-0" />
          <span className="text-xs sm:text-sm font-medium truncate">
            <span className="hidden sm:inline">Impersonando a: </span>
            <strong>{impersonationSession.impersonated_name}</strong>
            <span className="hidden md:inline"> &middot; Tenant: <strong>{impersonationSession.tenant_name}</strong></span>
            <span className="hidden lg:inline"> &middot; Modo: <strong className="uppercase">{impersonationSession.mode?.replace(/_/g, ' ')}</strong></span>
            <span className="hidden lg:inline"> &middot; Actor: {impersonationSession.impersonator_name}</span>
          </span>
        </div>
        <button
          onClick={handleEnd}
          className="flex items-center gap-2 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-lg transition-colors font-medium text-xs sm:text-sm self-end sm:self-auto flex-shrink-0"
          data-testid="end-impersonation-button"
        >
          <X className="w-4 h-4" />
          <span className="hidden sm:inline">Salir de impersonación</span>
          <span className="sm:hidden">Salir</span>
        </button>
      </div>
    </div>
  );
}
